import { t } from "../i18n";

// 드론 텔레메트리 mission_progress(문자열) → 화면 라벨 (드론팀 규격 2026-09-01).
// 값이 추가될 수 있으므로(규격 명시) 모르는 값은 오류가 아니라 원문 그대로 보여준다.
// 라벨 문구는 i18n mission 사전의 "progress.<값>" 키에 있다.
const KNOWN_PROGRESS = new Set([
  "idle",
  "uploaded",
  "arming",
  "takeoff",
  "moving",
  "hovering",
  "capturing",
  "returning",
  "landing",
  "complete",
]);

/** 라벨 문자열. 값이 없으면 null(표시 생략), 모르는 값은 원문. */
export function missionProgressLabel(progress) {
  if (typeof progress !== "string" || !progress) return null;
  const key = progress.trim().toLowerCase();
  return KNOWN_PROGRESS.has(key) ? t(`mission.progress.${key}`) : progress;
}
